import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { Formik } from "formik";
import * as Yup from "yup";
import { MyInput } from "../ui";
import Photo from "../assets/signup.jpg";
import Axios from "../Axios";
import LoginModal from "../modals/LoginModal/LoginModal";
import Popup from "../utils/Popup/Popup";
import HomeLayout from "../utils/Layouts/HomeLayout/HomeLayout";
import Banner from "../components/Home/Banner/Banner";
import CustomInput from "../components/shared/custom_input";
import {
  BiEdit,
  BiEnvelope,
  BiPhone,
  BiUser,
  BiUserCircle,
} from "react-icons/bi";
import { CgPassword } from "react-icons/cg";
import { MdPassword } from "react-icons/md";
import { GoArrowLeft, GoArrowRight } from "react-icons/go";

const logo = require("../assets/logo-with-bottom-name.png");

const _schemas = Yup.object().shape({
  firstname: Yup.string().required("Хоосон байна!"),
  lastname: Yup.string().required("Хоосон байна!"),
  phone_number: Yup.string()
    .matches(/^[0-9]*$/, "Зөвхөн тоо бичнэ үү!")
    .min(8, "Урт багадаа 8 байх ёстой!")
    .max(8, "8-аас их байж болохгүй!")
    .required("Хоосон байна!"),
  email: Yup.string()
    .email("Зөв форматаар бичнэ үү!")
    .matches(/[a-z0-9]+@[a-z]+\.[a-z]{2,3}/, "Зөв форматаар бичнэ үү!")
    .required("Хоосон байна!"),
  citizenship: Yup.string().required("Хоосон байна!"),
  password: Yup.string()
    .min(8, "Хамгийн багадаа 8 тэмдэгт байх ёстой!")
    .required("Хоосон байна!"),
  repassword: Yup.string()
    .oneOf([Yup.ref("password")], "Таарахгүй байна!")
    .required("Хоосон байна!"),
});

const SignUp = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navite = useNavigate();

  const [visibleLogin, setVisibleLogin] = useState(false);

  const [popupType, setPopupType] = useState("");
  const [popupText, setPopupText] = useState("");
  const [visiblePopup, setVisiblePopup] = useState(false);

  const signupHandler = (values) => {
    Axios.post("/auth/signup", values)
      .then((res) => {
        if (res.data.message === "success") {
          setPopupType("success");
          setPopupText("Та амжилттай бүртгүүллээ");
          setVisiblePopup(true);
        }
      })
      .catch((err) => {
        if (err.response.status >= 400 && err.response.status < 500) {
          setPopupType("error");
          setPopupText(err.response.data.message);
        } else {
          setPopupType("sys_error");
          setPopupText("Ямар нэгэн алдаа гарлаа. Та дахин оролдоно уу!");
        }

        setVisiblePopup(true);
      });
  };

  const popupOnOK = () => {
    if (String(popupType).includes("error")) {
      window.location.reload();
    } else {
      setVisiblePopup(false);

      setVisibleLogin(true);
    }
  };

  return (
    <HomeLayout>
      <LoginModal visible={visibleLogin} setVisible={setVisibleLogin} />
      <Popup
        messageType={popupType}
        messageText={popupText}
        visible={visiblePopup}
        onOk={popupOnOK}
      />
      <div className="w-full max-w-[1920px] m-auto">
        <Banner />

        <div className="max-w-[800px] m-auto">
          {/* <button
            className="no-button signup__content-goBack"
            onClick={() => navite(-1)}
          >
            <IoIosArrowBack /> Буцах
          </button> */}

          <div className="text-center text-white md:text-[32px] text-[24px] uppercase md:pt-16 pt-10 font-semibold mb-8">
            <h3 className="">Бүртгүүлэх</h3>
          </div>

          <Formik
            initialValues={{
              firstname: "",
              lastname: "",
              phone_number: "",
              email: "",
              citizenship: "",
              password: "",
              repassword: "",
            }}
            validationSchema={_schemas}
            onSubmit={(vals) => signupHandler(vals)}
          >
            {({
              values,
              errors,
              touched,
              setFieldTouched,
              setFieldValue,
              handleChange,
              handleSubmit,
            }) => (
              <form
                className="flex flex-col gap-4 px-10 md:px-0"
                onSubmit={handleSubmit}
              >
                <span className="flex gap-4 md:flex-row flex-col">
                  <CustomInput
                    label={"Овог"}
                    value={values.lastname}
                    onChange={(e) => {
                      setFieldValue("lastname", e);
                      setFieldTouched("lastName", true);
                    }}
                    icon={<BiUserCircle />}
                    touched={touched.lastname}
                    errorText={errors.lastname}
                  />
                  <CustomInput
                    label={"Нэр"}
                    value={values.firstname}
                    onChange={(e) => {
                      setFieldValue("firstname", e);
                      setFieldTouched("firstname", true);
                    }}
                    icon={<BiUserCircle />}
                    touched={touched.firstname}
                    errorText={errors.firstname}
                  />
                </span>
                <CustomInput
                  label={"Утасны дугаар"}
                  value={values.phone_number}
                  onChange={(e) => {
                    setFieldValue("phone_number", e);
                    setFieldTouched("phone_number", true);
                  }}
                  keyboardType="number"
                  icon={<BiPhone />}
                  touched={touched.phone_number}
                  errorText={errors.phone_number}
                />
                <CustomInput
                  label={"И-мэйл хаяг"}
                  value={values.email}
                  keyboardType={"email"}
                  onChange={(e) => {
                    setFieldValue("email", e);
                    setFieldTouched("email", true);
                  }}
                  icon={<BiEnvelope />}
                  touched={touched.email}
                  errorText={errors.email}
                />
                <div className="ext-[16px] font-semibold text-gray-100">
                  Иргэншил
                </div>
                <select
                  label="Иргэншил"
                  name="citizenship"
                  value={values.citizenship}
                  onChange={handleChange}
                  onBlur={() => setFieldTouched("citizenship")}
                  touched={touched.citizenship}
                  errorText={errors.citizenship}
                  className="bg-white rounded-xl h-14 text-[16px] font-medium text-gray-600"
                >
                  <option value="">-- сонгох --</option>
                  <option value="Монгол">Монгол</option>
                  <option value="Бусад">Бусад</option>
                </select>
                <CustomInput
                  label={"Нууц үг"}
                  value={values.password}
                  keyboardType={"password"}
                  onChange={(e) => {
                    setFieldValue("password", e);
                    setFieldTouched("password", true);
                  }}
                  icon={<MdPassword />}
                  touched={touched.password}
                  errorText={errors.password}
                />
                <CustomInput
                  label={"Нууц үг давтах"}
                  value={values.repassword}
                  keyboardType={"password"}
                  onChange={(e) => {
                    setFieldValue("repassword", e);
                    setFieldTouched("repassword", true);
                  }}
                  icon={<MdPassword />}
                  touched={touched.repassword}
                  errorText={errors.repassword}
                />

                {/* <div className='signup__content-form-checkText'>
                  <Checkbox
                    id='readTos'
                    name='readTos'
                    onChange={(e) =>
                      console.log(`${e.target.name}:`, e.target.checked)
                    }
                  >
                    Би 18 нас хүрсэн бөгөөд <b>үйлчилгээний нөхцөл</b>-тэй
                    танилцсан.
                  </Checkbox>

                  <Checkbox
                    id='readPrivacy'
                    name='readPrivacy'
                    onChange={(e) =>
                      console.log(`${e.target.name}:`, e.target.checked)
                    }
                  >
                    <b>Нууцлалын бодлого</b>-той уншиж танилцсан.
                  </Checkbox>
                </div> */}
                <div className="flex md:gap-4 border-b-[1px] border-gray-600 pb-8 mb-6 mt-6 md:flex-row flex-col gap-8">
                  <button
                    onClick={() => {}}
                    className="rounded-full border-0 flex-1 bg-[#000] py-4 flex items-center justify-center text-white font-semibold text-3xl gap-4 select-none cursor-pointer"
                  >
                    <GoArrowLeft size={24} />
                    <span>Нууц үг сэргээх</span>
                  </button>
                  <button
                    type="submit"
                    className="rounded-full border-0 flex-1 bg-[#1e0088] py-4 flex items-center justify-center text-white font-semibold text-3xl gap-4 select-none cursor-pointer"
                  >
                    <span>Бүртгүүлэх</span>
                    <GoArrowRight size={24} />
                  </button>
                </div>
              </form>
            )}
          </Formik>

          <div className="flex items-center justify-between w-full text-white md:px-0 px-10">
            <div>Та бүртгэлтэй бол</div>
            <div
              className="select-none cursor-pointer"
              onClick={() => setVisibleLogin(true)}
            >
              Энд дарж нэвтэрнэ үү?
            </div>
          </div>
        </div>
      </div>

      {/* Яг хаана нь оруулхаа мэдэхгүй байсан учираас энд оруулчихсан шүү хө */}
      <div className="lg:px-32 md:px-20 px-6 text-gray-400 text-[14px]">
        <div className="bg-[#071949] rounded-4xl shadow-2xl px-12">
          <div className="flex border-b-[1px] border-gray-500 pt-6 mb-6 text-[16px]">
            <div className="flex overflow-x-auto whitespace-nowrap">
              {[
                "Хувийн мэдээлэл",
                "Нууц үг солих",
                "Миний хичээлүүд",
                "Миний шалгалтууд",
                "Миний захиалгын түүх",
              ].map((e, index) => (
                <div
                  key={e}
                  className={`w-[200px] flex-shrink-0 rounded px-4 py-2 bg-transparent border-b-[2px] pb-6 cursor-pointer select-none ${index === currentIndex ? "border-gray-300 font-semibold" : "border-transparent"}`}
                  onClick={() => {
                    if (currentIndex === index) {
                      return;
                    }
                    setCurrentIndex(index);
                  }}
                >
                  {e}
                </div>
              ))}
            </div>
          </div>
          <div className="flex gap-12 mt-16 pb-16 md:flex-row flex-col">
            <div className="flex justify-center">
              <div className="w-56 h-56 relative">
                <div className="bg-[#1a15ed] rounded-full absolute right-0 bottom-8 p-2 select-none cursor-pointer">
                  <BiEdit size={24} />
                </div>
                <img
                  className="w-56 h-56 rounded-full object-cover object-center"
                  src="https://cdn.prod.website-files.com/5ec7dad2e6f6295a9e2a23dd/66fcde00cf54d71747a52bac_upwork-profile-photo-tips.jpg"
                  alt=""
                />
              </div>
            </div>
            <div className="flex-1 grid md:grid-cols-2 grid-cols-1 gap-6">
              <CustomInput label={"Овог"} icon={<BiUserCircle />} />
              <CustomInput label={"Нэр"} icon={<BiUserCircle />} />
              <CustomInput
                label={"Утасны дугаар"}
                keyboardType="number"
                icon={<BiPhone />}
              />
              <CustomInput label={"И-мэйл хаяг"} icon={<BiEnvelope />} />
              <div />
              <div>
                <button className="rounded-full w-full border-0 flex-1 bg-[#1e0088] py-4 flex items-center justify-center text-white font-semibold text-3xl gap-4 select-none cursor-pointer flex-1">
                  <span>Хадгалах</span>
                  <GoArrowRight size={24} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </HomeLayout>
  );
};

export default SignUp;
